var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { NetworkError } from '../webError';
import { ActivityType } from './types';
export var tokenType;
(function (tokenType) {
    tokenType["ASSET"] = "asset";
    tokenType["PRODUCT"] = "product";
    tokenType["PRODUCT_ITEM"] = "product_item";
    tokenType["USER"] = "user";
    tokenType["CONSIGNMENT"] = "consignment";
    tokenType["BUSINESS"] = "business";
    tokenType["GROUP"] = "group";
    tokenType["SITE"] = "site";
})(tokenType || (tokenType = {}));
export function createTokenOffChain(userId, tokens, config) {
    return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
        const data = {
            userId,
            blockchain: true,
            tokens,
        };
        callAPI({ method: 'POST', url: config.url, data })
            .then((response) => {
            resolve(response);
        })
            .catch((error) => {
            reject(error);
        });
    }));
}
export function createActivityOffChain(userId, tokens, newActivities, config) {
    return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
        const data = {
            userId,
            tokens: tokens.map(token => Object.assign(token, { activities: newActivities })),
        };
        callAPI({ method: 'POST', url: config.url, data })
            .then((response) => {
            resolve(response);
        })
            .catch((error) => {
            reject(error);
        });
    }));
}
// create token
export function createToken_full(userId, tokens, privateKey, config) {
    return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
        try {
            // 1. create asset off-chain
            const offChainRes = yield createTokenOffChain(userId, tokens, config);
            resolve(offChainRes);
        }
        catch (error) {
            // errorType
            reject(error);
        }
    }));
}
function networkErrorHandler(error) {
    console.log("networkErrorHandler -> error", error, error.response);
    let networkError;
    if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        const errorResponse = error.response.data;
        networkError = {
            status: error.response.status,
            type: Array.isArray(errorResponse)
                ? errorResponse[0].code
                : errorResponse.code,
            message: Array.isArray(errorResponse)
                ? errorResponse[0].details
                : errorResponse.details,
            data: Array.isArray(errorResponse)
                ? errorResponse[0].source
                : errorResponse.source,
            title: errorResponse.title,
            solution: errorResponse.solution,
            originalErr: errorResponse
        };
    }
    else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
        networkError = {
            status: 500,
            type: 'E_REQUEST_MADE_NO_RESPONSE',
            message: 'The request was made but no response was received.',
            data: null,
            title: 'Unexpected Error',
            solution: 'Unexpected Error',
            originalErr: error,
        };
    }
    else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
        networkError = {
            status: 400,
            type: 'E_REQUEST_ERROR',
            message: 'The request has error.',
            data: null,
            title: 'Unexpected Error',
            solution: 'Unexpected Error',
            originalErr: error,
        };
    }
    return networkError;
}
export function callAPI(config) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function* () {
        try {
            config.headers = Object.assign(Object.assign({}, config.headers), { 'Content-Type': 'application/json' });
            // All authentication route ( /auth ) should allow exchange of cookies except for /auth/register
            if (((_a = config.url) === null || _a === void 0 ? void 0 : _a.includes('/auth')) && !((_b = config.url) === null || _b === void 0 ? void 0 : _b.includes('/register'))) {
                Object.assign(config, { withCredentials: true });
            }
            const response = yield axios.request(config);
            return response.data;
        }
        catch (e) {
            if (((_c = e.response) === null || _c === void 0 ? void 0 : _c.status) === 401 && e.response.data) {
                e.response.data.title = "Session expired";
                e.response.data.details = "Please login again";
            }
            throw new NetworkError(e);
        }
    });
}
//read token by external id
export function readToken_ExternalId(externalIdArray, config, ifLatestDetails, exist) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const data = {
                latestDetails: ifLatestDetails,
                externalIds: externalIdArray,
            };
            if (exist) {
                data.status = ['exist'];
            }
            const response = yield callAPI({ method: 'POST', url: config.url, data });
            return response;
        }
        catch (e) {
            if ('networkError' in e && 'errorForModal' in e) {
                const { networkError, errorForModal } = e;
                console.error(networkError);
                throw errorForModal;
            }
            else {
                console.error(e);
                throw e;
            }
        }
    });
}
//update token
export function updateToken(userId, tokens, newActivities, config) {
    return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
        try {
            let activities = [];
            newActivities.map(newActivity => {
                const mergeActivity = Object.assign({ type: ActivityType.UPDATE_TOKEN }, newActivity);
                activities.push(mergeActivity);
            });
            createActivityOffChain(userId, tokens, activities, config)
                .then((response) => {
                resolve(response);
            })
                .catch(e => {
                throw e;
            });
        }
        catch (error) {
            reject(error);
        }
    }));
}
// export async function getTokensByUser(
//   userId: string,
//   tokenType: Array<string> = [],
//   activityTypeArray: Array<string> = [],
//   latestDetails: boolean = true,
//   status: Array<string> = ['exist'],
// ) {
//   const url = `${getAPI().POST.getTokenByUser}`;
//   const data: {[k: string]: any} = {
//     userId,
//     latestDetails,
//     status,
//     type: tokenType,
//     activityType: activityTypeArray,
//   };
//   const PostMethod: Method = 'POST';
//   try {
//     const response = await callAPI(url, PostMethod, data);
//     return response;
//   } catch (error) {
//     throw error.errorForModal;
//   }
// }
